<template>
<span class="d-inline-block border-radius" :style="{backgroundColor: color}">
  {{ state }}
</span>
</template>

<script>
import {getMappedTask} from "@/pipelineUtils";
import {TaskManagerStates, TaskManagerTaskColors} from "@/enum";

export default {
  name: "PipelineCompactStateViewer",
  props: {
    item: {type: Object, default: () => {}}
  },
  data() {
    return {
      TaskManagerTaskColors,
      TaskManagerStates
    }
  },
  computed: {
    taskEntries() {
      return this.item ? this.item.taskManagerRows : null;
    },
    taskEntry() {
      return this.taskEntries && this.taskEntries[0] ? this.taskEntries[0] : null;
    },
    mappedTask() {
      return getMappedTask(this.taskEntry);
    },
    color() {
      if(!this.mappedTask) {
        const {state} = this.item;
        return state === 'a' ? 'green' : 'grey';
      }
      return this.mappedTask ? TaskManagerTaskColors[this.mappedTask.prio] : '';
    },
    state() {
      if(!this.mappedTask) {
        const {state} = this.item;
        return state === 'a' ? 'ready' : 'not ready';
      }
      return this.mappedTask ? 'pipeline: ' + TaskManagerStates[this.mappedTask.prio] : '';
    },
  }
}
</script>